import React from "react";
import { withRouter } from "react-router-dom";
import CreatePayment from "./CreatePayment";
import Header from "../../components/Header/index";
import { app_path } from "config";
import PrivateRoutes from "../../components/Routes/PrivateRoutes";

class VoucherPayment extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      addFund: 0,
      company_recharge: "",
      udfUrl: "", //fasdfasfasdfasdf
      contact: "", //profoma invoice payment,
      sales_order_id: 0,
      is_proforma_invoice: 0,
    };
  }

  handleRedirect = () => {
    if (
      this.props.location.state == undefined ||
      this.props.location.state < 1 ||
      this.props.location.state == ""
    ) {
      this.props.history.push(`/${app_path}`);
    } else {
      let data = JSON.parse(this.props.location.state);
      this.setState({
        addFund: data.amount,
        currencySymbol: data.currencySymbol,
        companyDetails: data.companyDetails,
        company_recharge: data.company_recharge,
        udfUrl: data.udfUrl ? data.udfUrl : "",
        product_type: data.product_type,
        contact: data.contact, //profoma invoice payment
        sales_order_id: data.sales_order_id,
        is_proforma_invoice: data.is_proforma_invoice,
        otp_id: data.otp_id,
      });
    }
  };

  componentWillMount() {
    this.handleRedirect();
  }

  render() {
    const { accountReducer } = this.props;
    const adminPrefix = `/${app_path}/`;
    const { match = this.props.location.pathname } = this.props;
    return (
      <div className="paymentWrapper ">
        <div className="container-fluid ">
          {/* <Header
            companyDetails={accountReducer && accountReducer.companyDetails}
            employeeDetails={accountReducer && accountReducer.employeeDetails}
            accountReducer={accountReducer}
            privateRoutes={() => (
              <PrivateRoutes
                pathname={this.props.location.pathname}
                adminPrefix={adminPrefix}
                match={match}
                {...this.state}
                {...this.props}
                fetchAdminDetails={this.fetchAdminDetails}
              />
            )}
          /> */}
          <CreatePayment
            currencySymbol={this.state.currencySymbol}
            addFund={this.state.addFund}
            companyDetails={this.state.companyDetails}
            company_recharge={this.state.company_recharge}
            udfUrl={this.state.udfUrl}
            product_type={this.state.product_type}
            contact={this.state.contact}
            sales_order_id={this.state.sales_order_id}
            is_proforma_invoice={this.state.is_proforma_invoice}
            {...this.props}
            accountReducer={accountReducer}
            otp_id={this.state.otp_id}
            updateKybStatus={this.props.updateKybStatus}
            updateAllowedDomains={this.props}
            updateClientId={this.props.updateClientId}
            updateDistributionType={this.props.updateDistributionType}
          />
        </div>
      </div>
    );
  }
}

export default withRouter(VoucherPayment);
